export default "__VITE_ASSET__CsQnckUh__"